import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from 'app/shared/log/log.service';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { EventCollisionService } from '../event-collision/event-collision.service';
import { EventMatchLogHttpService } from './event-match-log.http.service';
import { Observable } from 'rxjs/Observable';
import { DateUtil } from 'app/shared/utils/date.util';

@Injectable()
export class EventMatchLogStore {

  constructor(
    private flashMessagesService: FlashMessagesService,
    private logService: LogService,
    private translateService: TranslateService,
    private eventCollisionService: EventCollisionService,
    private eventMatchLogHttpService: EventMatchLogHttpService
  ) {
    this.init();
  }

  private init(): void {
  }

  getEventMatchLog(page: number, size: number, sortField: string, secondarySortField: string, sortDirection: string): Observable<any> {
    let sort = 'sort=' + sortField + ',' + sortDirection;
    if (secondarySortField) {
      sort = sort + '&sort=' + secondarySortField + ',' + sortDirection;
    }

    return this.eventMatchLogHttpService.getEventMatchLog(page, size, sort).catch(error => {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_MATCHING_PROPERTIES'));
      this.logService.error(`Error getting Matching Properties: ${error}`);
      return Observable.throw(error);
    }).map(propertyMatches => {
      return propertyMatches;
    });
  }

  exportEventMatchLogExcel(): Observable<any> {
    return this.eventMatchLogHttpService.exportEventMatchLogExcel().map( data => {
      saveAs(data, 'event_atch_log_' + DateUtil.formatDate(new Date(), 'YYYYMMDD') + '.xlsx');
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/event-match-log.store.ts